{
    "noesis": {
        "page_title": "Noesis",
        "page_subtitle": "Tu agente de IA para un monitoreo ambiental más inteligente",
        "chart": {
            "unavailable": "No se puede mostrar este gráfico.",
            "download": "Descargar gráfico",
            "download_png": "Imagen (PNG)",
            "download_svg": "Imagen (SVG)",
            "download_csv": "Datos (CSV)"
        },
        "buttons": {
            "new_chat": "Nueva conversación",
            "ask": "Preguntar a Noesis"
        },
        "input": {
            "placeholder": "Pregúntale a Noesis...",
            "edit_placeholder": "Edita tu mensaje..."
        },
        "token_limit": {
            "reached": "Se alcanzó el límite de tokens. Inicia una nueva conversación para continuar."
        },
        "token_usage": {
            "title": "Uso de tokens",
            "aria": "Uso de tokens {{percent}} por ciento del límite"
        },
        "voice": {
            "start_recording": "Grabar un mensaje de voz",
            "dictate": "Dictar",
            "cancel_recording": "Cancelar grabación",
            "apply_recording": "Transcribir mensaje de voz",
            "transcribing": "Transcribiendo…",
            "mic_permission_denied": "El acceso al micrófono está bloqueado. Habilítalo en la configuración de tu navegador para usar mensajes de voz.",
            "no_audio_captured": "No se capturó audio. Inténtalo de nuevo.",
            "transcription_failed": "No se pudo transcribir tu mensaje de voz. Inténtalo de nuevo."
        },
        "files": {
            "attach": "Adjuntar archivo de datos (CSV, XLSX)",
            "remove": "Eliminar archivo",
            "unsupported": "\"{{name}}\" no es compatible. Adjunta un archivo CSV o XLSX.",
            "too_large": "\"{{name}}\" supera los {{max}} MB.",
            "too_many": "Puedes adjuntar hasta {{max}} archivos.",
            "upload_failed": "No se pudo subir \"{{name}}\". Inténtalo de nuevo.",
            "remove_failed": "No se pudo eliminar el archivo. Inténtalo de nuevo."
        },
        "welcome": {
            "title": "¿Necesitas información? Solo pregunta.",
            "examples": {
                "air_quality": "¿Cuál fue la calidad del aire hoy para los dispositivos de oficina según el estándar Well V2 para espacios interiores?",
                "smoke_detection": "Detecta cualquier humo durante las últimas 6 horas para dispositivos del piso 5",
                "pdf_report": "Genera un informe PDF de los niveles de PM2.5 para los dispositivos 1C041149, 1C083036 durante la última semana con gráficos de tendencias",
                "csv_export": "Exporta a CSV Conc. de Masa Total superior a 0.015 mg/m³ usando promedio de 15 minutos de las últimas 24 horas",
                "device_diagnostics": "Diagnostica dispositivos con sensores DustTrak"
            }
        },
        "messages": {
            "processing": "Procesando tu solicitud..."
        },
        "actions": {
            "try_again": "Intentar de nuevo",
            "edit_message": "Editar mensaje"
        },
        "threads_sidebar": {
            "empty_title": "Aún no hay conversaciones",
            "empty_description": "Inicia una nueva conversación para comenzar",
            "delete_thread": "Eliminar Conversación"
        },
        "chats_panel": {
            "title": "Conversaciones",
            "search_placeholder": "Buscar conversaciones",
            "search_empty": "No se encontraron conversaciones",
            "about_link": "Acerca de Noesis",
            "demo_link": "Solicitar una Demo",
            "pinned_group": "Fijados",
            "recent_group": "Recientes",
            "rename": "Renombrar",
            "pin": "Fijar arriba",
            "unpin": "Dejar de fijar",
            "chat_options": "Opciones de la conversación",
            "processing": "Procesando"
        }
    }
}